export class Store {
  read(key: string): any {
    return window.localStorage.getItem(key);
  }

  write(key: string, val: any): void {
    window.localStorage.setItem(key, val);
  }

  remove(key: string): void {
    window.localStorage.removeItem(key);
  }

  clearAll() {
    window.localStorage.clear();
  }
}



// WEBPACK FOOTER //
// ./src/libs/store.ts